
export abstract class BaseModel<F, B, IdType = number> {
    id?: IdType;
    name?: string;
    abstract toApiModel(): B;
    abstract clone(): F;
    abstract equals(other?: F): boolean;
    abstract constructFromApiModel(apiModel: B): void;
    abstract constructDefault(): void;
}
